module.exports = __webpack_public_path__ + "static/media/wordmark.df59a342.svg";